import React, { useState } from 'react';
import HeroSection from '../components/HeroSection';
import WhySection from '../components/WhySection';
import VideoSection from '../components/VideoSection';
import WhoSection from '../components/WhoSection';
import TestimonialSection from '../components/TestimonialSection';
import GallerySection from '../components/GallerySection';
import ClienteleSection from '../components/ClienteleSection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="home-page">
      <HeroSection />
      <WhySection />
      <VideoSection />
      <WhoSection />
      <TestimonialSection />
      <GallerySection />
      <ClienteleSection />
      <Footer />
    </div>
  );
};

export default Home;